<template>
<rpm-modal persist :open="open" class="flex flex-col gap-y-8" @close="form.content = '', $emit('close')">
  <div class="w-full border-b pb-3">
    <h2 class="text-xl font-bold text-left">
      Cancelar Situação
    </h2>
  </div>

  <div class="text-center flex flex-col gap-1">
    <h3 class="text-lg font-semibold">
      Serviço: 
      <span class="text-red-600">
        {{ situation?.source_procedure?.name || 'Não informado' }}
      </span>
    </h3>

    <p class="text-sm text-default/80 dark:text-white/80">
      Você tem certeza que deseja cancelar a situação 
      <strong>ID {{ situation?.id }}</strong>?
      Esta ação não poderá ser desfeita.
    </p>
  </div>

  <section class="flex flex-row justify-center gap-6">
    <rpm-button
      @click="$emit('close')"
      color="gray"
      label="Não"
    ></rpm-button>

    <rpm-button
      label="Sim, cancelar"
      color="red"
      @click="cancelService"
    ></rpm-button>
  </section>
</rpm-modal>

</template>

<script>

import RpmModal from "#components/RpmModal.vue";
import deleteSourceProcedureSituationepository from "../../../../../../js/repositories/sourceProcedureSituationRepository";

export default {
  name: 'CancelServiceModal',
  components: {
    RpmModal
  },
  props: {
    situation: {
      type: Object
    },
    open: {
      type: Boolean
    }
  },
  data() {
    return {
      form: {
        content: ''
      },
      errors: {}
    }
  },
  methods: {
  cancelService() {
  deleteSourceProcedureSituationepository.deleteSourceProcedureSituation(this.situation.id)
    .then(() => {
      this.$notify('Solicitação cancelada com sucesso', 'success');
      this.$emit('canceled');
      this.$emit('close');
    })
    .catch(() => {
      this.$notify('Erro ao cancelar solicitação', 'error');
    });
}
  
  }
}
</script>